// /*--------------------------------------------------------------
// # Custom scripts for testimonial Reel block
// --------------------------------------------------------------*/

var testimonialReelSlider = jQuery('.testimonial-reel-slider');
// slick slider settings
var testimonialReelSliderSettings = {
    mobileFirst: true,
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-arrow slick-prev"><span class="visually-hidden">Previous</span></button>',
    nextArrow: '<button class="slick-arrow slick-next"><span class="visually-hidden">Next</span></button>',
	variableWidth: true,
	responsive: [
        {
            breakpoint: 992,
            settings: {
				slidesToShow: 2,
            }
        },
        {
            breakpoint: 1200,
            settings: {
				slidesToShow: 4,
            }
        }
    ]

}

// Function to change slider settings
var changeSliderSettingsBreakpoint = [{breakpoint: 992, settings: {slidesToShow: 2}}, {breakpoint: 1200, settings: {slidesToShow: 2}}];
function changeSliderSettings() {
    testimonialReelSlider.slick('slickSetOption', 'responsive', changeSliderSettingsBreakpoint, true);
}

if (testimonialReelSlider.length > 0) {
    // set slides to same height
    testimonialReelSlider.on('setPosition', function () {
        jQuery(this).find('.testimonial-reel-slider__item').height('auto');
        var slickTrack = jQuery(this).find('.slick-track');
        var slickTrackHeight = jQuery(slickTrack).height();
        jQuery(this).find('.testimonial-reel-slider__item').css('height', slickTrackHeight + 'px');
    });

    // work out resize function to reinit or destroy slider on load and window resize
    jQuery(window).on('load resize', function() {        
        // init slider if not already initialised
        testimonialReelSlider.not('.slick-initialized').slick(testimonialReelSliderSettings);
        
        // if slider is inside tabbed content change settings
        if ( testimonialReelSlider.parents().hasClass('tab-pane') ) {
            changeSliderSettings();
        }
    });

    // re init when in bootstrap tabbed content
    jQuery('[data-bs-toggle="tab"]').on('shown.bs.tab', function() {
        testimonialReelSlider.slick('setPosition');
    })
}